import { render } from "./SectionBlock.vue?vue&type=template&id=9ef50f94&scoped=true"
import script from "./SectionBlock.vue?vue&type=script&lang=js"
export * from "./SectionBlock.vue?vue&type=script&lang=js"

import "./SectionBlock.vue?vue&type=style&index=0&id=9ef50f94&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef50f94"]])

export default __exports__